import React from 'react';
import { Scale, Menu } from 'lucide-react';

interface HeaderProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
}

export function Header({ mobileMenuOpen, setMobileMenuOpen }: HeaderProps) {
  const scrollToContact = () => {
    const contactForm = document.getElementById('contact-form');
    contactForm?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
    setTimeout(() => {
      const nameInput = document.getElementById('name') as HTMLInputElement;
      nameInput?.focus();
    }, 800);
  };

  return (
    <header className="relative h-[600px] md:h-[700px]" role="banner">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1575505586569-646b2ca898fc?auto=format&fit=crop&q=80")',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
        aria-hidden="true"
      >
        <div className="absolute inset-0 bg-gray-900/70"></div>
      </div>
      
      <nav className="relative z-10 container mx-auto px-4 sm:px-6 py-6" role="navigation" aria-label="Main navigation">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Scale className="h-8 w-8 text-white" aria-hidden="true" />
            <span className="text-white text-xl sm:text-2xl font-semibold">Israeli.Law</span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8 text-white">
            <a href="#services" className="hover:text-blue-400 transition">Services</a>
            <a href="#about" className="hover:text-blue-400 transition">About</a>
            <a href="#contact" className="hover:text-blue-400 transition">Contact</a>
            <button 
              onClick={scrollToContact}
              className="bg-blue-600 px-6 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Get Started
            </button>
          </div>

          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </nav>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 pt-20 md:pt-32">
        <h1 className="text-4xl sm:text-5xl font-bold text-white max-w-3xl">
          Navigating Israeli Law, Simplified for You
        </h1>
        <p className="text-lg sm:text-xl text-gray-200 mt-6 max-w-2xl">
          Full-service legal support for international clients in Israel. Beyond just legal documentation - we're your comprehensive guide through Israeli law, culture, and bureaucracy.
        </p>
        <a 
          href="https://wa.me/972545665473"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 bg-blue-600 text-white px-6 sm:px-8 py-3 rounded-lg inline-flex items-center space-x-3 hover:bg-blue-700 transition group"
          aria-label="Send WhatsApp message"
        >
          <img 
            src="https://img.icons8.com/?size=100&id=16713&format=png&color=000000"
            alt=""
            className="h-5 w-5 invert"
            width="20"
            height="20"
          />
          <span>Send me a message</span>
        </a>
      </div>
    </header>
  );
}